// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"4f9745ad","141":"148baebe","245":"66bb14a3","467":"7d75cde4","508":"668a5da3","560":"9269792b","670":"250dd103","683":"32aa7d84","787":"b0bea7be"}[chunkId] + ".chunk.js";
};